import { render, staticRenderFns } from "./CardRatingTalentMaping.vue?vue&type=template&id=030b921e"
import script from "./CardRatingTalentMaping.vue?vue&type=script&lang=ts"
export * from "./CardRatingTalentMaping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030b921e')) {
      api.createRecord('030b921e', component.options)
    } else {
      api.reload('030b921e', component.options)
    }
    module.hot.accept("./CardRatingTalentMaping.vue?vue&type=template&id=030b921e", function () {
      api.rerender('030b921e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rating/CardRatingTalentMaping.vue"
export default component.exports